import { call, put, takeLatest } from 'redux-saga/effects';
import { GET_USER, SIGN_UP, User } from './appModel';
import appApi from './appApi';
import {
  getUserFail,
  getUserSuccess,
  signUp,
  signUpFail,
  signUpSuccess,
} from './appActions';

export function* getUserSaga() {
  try {
    const { data: response } = yield call(appApi.getUser);
    const user: User = {
      id: response.userId,
      email: response.email,
    };
    yield put(getUserSuccess(user));
  } catch (error) {
    console.error(error);
    yield put(getUserFail());
  }
}

export function* signUpSaga(action: ReturnType<typeof signUp>) {
  const { formData, onConfirm } = action.payload;

  try {
    yield call(appApi.signUp, formData);
    yield put(signUpSuccess());
    yield call(onConfirm);
  } catch (error) {
    console.error(error);
    yield put(signUpFail());
  }
}

export function* appSaga() {
  yield takeLatest(GET_USER, getUserSaga);
  yield takeLatest(SIGN_UP, signUpSaga);
}
